import React from 'react'
import {
  CarouselControls,
  CarouselNextButton,
  CarouselPreviousButton,
  CarouselRoot,
  CarouselScrollArea,
  CarouselState,
  ScreenReaderOnly,
} from '@moonpig/launchpad-components'
import { Suggestion } from '../../ChatMessages/types'
import { useLocaleText } from '../../locale'
import {
  StyledIconSystemInformation,
  StyledSuggestionsContainer,
  StyledSuggestionTitleFlex,
  StyledSuggestionTitleText,
  SuggestionsAgentMessageStyledButton,
} from './styled'

export const SuggestionsAgentMessage = ({
  title,
  suggestions,
  suggestionClickHandler,
  id,
}: {
  title?: string
  suggestions: string[]
  suggestionClickHandler: (
    suggestion: Suggestion,
    suggestionOptions: number,
  ) => void
  id: number
}) => {
  const t = useLocaleText()
  const labelId = `chat-suggestions-label-${id}`
  const titleId = `chat-suggestions-title-${id}`
  const descriptionId = `chat-suggestions-description-${id}`
  const hasSelectableSuggestions = suggestions.length > 0

  return (
    <StyledSuggestionsContainer
      aria-labelledby={`${labelId} ${titleId}`}
      aria-describedby={hasSelectableSuggestions ? descriptionId : undefined}
      data-testid="chat-suggestions-container"
      role="article"
    >
      <ScreenReaderOnly id={labelId}>
        {t('concierge_chat.screen_reader_assistant_label')}
      </ScreenReaderOnly>
      <StyledSuggestionTitleFlex>
        <StyledSuggestionTitleText id={titleId}>
          {title || t('concierge_chat.quick_prompts_title')}
        </StyledSuggestionTitleText>
        <StyledIconSystemInformation />
      </StyledSuggestionTitleFlex>
      {hasSelectableSuggestions && (
        <ScreenReaderOnly id={descriptionId}>
          {t('concierge_chat.suggestions_screen_reader_hint')}
        </ScreenReaderOnly>
      )}

      <CarouselState>
        <CarouselRoot
          aria-label={t('concierge_chat.suggestions_screen_reader_hint')}
          style={{ padding: 0 }}
        >
          <CarouselControls>
            <CarouselPreviousButton />
            <CarouselNextButton />
          </CarouselControls>
          <CarouselScrollArea style={{ gap: '12px' }}>
            {suggestions.map((suggestion, suggestionId, suggestionOptions) => (
              <SuggestionsAgentMessageStyledButton
                key={`suggestion-agent-${suggestion.replace(/\s/g, '-')}`}
                onClick={() =>
                  suggestionClickHandler(
                    {
                      text: suggestion,
                      id: suggestionId + 1,
                      source: 'agent',
                    },
                    suggestionOptions.length,
                  )
                }
              >
                {suggestion}
              </SuggestionsAgentMessageStyledButton>
            ))}
          </CarouselScrollArea>
        </CarouselRoot>
      </CarouselState>
    </StyledSuggestionsContainer>
  )
}
